import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: {
      label: {},
      error: {},
      message: {},
      text: 
      { 
        empty  :"" , 
        noMissions : "there is no missions" , 
        hello: "hello" , 
        company_name : "Company name" ,
        home : "Home" , 
        missions : "Missions" , 
        questionnaires : "Questionnaires" , 
        subscription : "Subscription"  , 
        Company_name : "Company name" ,
        Company_Website : "Company Website" ,
        Company_Email : "Company Email" ,
        Password : "Password" , 
        Confirm_Password : "Confirm Password" ,
        Commercial_Registration_No : "Commercial Registration No" , 
        Copy_of_the_commercial_register : "Copy of the commercial register"  ,
        Upload : "Upload" , 
        Create_Account : "Create Account" , 
        The_application_is_currently_being_reviewed : "The application is currently being reviewed" , 
        We_will_contact_you_to_verify_the_data_and_some_other_information : "We will contact you to verify the data and some other information" , 
        Visit_Site : "Visit Site" , 
        Welcome_back : "Welcome back" , 
        Phone_Number : "Phone Number" , 
        Forget_Password : "Forget Password ?" ,
        Login : "Login" , 
        Didnt_have_an_account : "Didn't have an account ?" , 
        Register : "Register" , 
        Enter_your_phone_number : "Enter your phone number" , 
        We_need_your_phone_number_to_create_an_account_and_log_in_with_later : "we need your phone number to create an account and log in with later" , 
        confirm :"confirm" , 
        You_will_receive_an_email_with_a_verification_code_on : "You will receive   a verification code on" , 
        Verify : "Verify" , 
        change : "change" , 
        Didnt_receive_anything : "Didn’t receive anything?" , 
        Send_again_after : "Send again after" , 
        seconds :"seconds" ,
        Available_Missions : "Available Visits" , 
        Highest_rating : "Highest rating" , 
        Lowest_rating : "Lowest rating" , 
        New_Missions : "New Missions" , 
        published : "published" , 
        Support : "Support" , 
        Messages : "Messages" ,
        Mystery_Support : "Mystery Support" ,
        select_a_message_from_the_side_bar : "select a message from the side bar" ,
        Send : "Send" ,
        Enter_Message : "Enter Message" ,
        Post_Mission : "Post Mission" ,
        Title : "Title" ,
        Focus : "Focus" ,
        Branch : "Branch" ,
        Date : "Date" ,
        Time : "Time" ,
        from : "from" , 
        to : "to"  , 
        Purchase_voucher : "Purchase voucher" ,
        Questionnaire : "Questionnaire" ,
        total_balance : "total balance" ,
        SAR : "SAR" ,
        New_Mission : "New Mission" ,
        type_what_you_want_him_her_to_focus_on : "type what you want him/her to focus on!" , 
        Include_Purchase_voucher : "Include Purchase voucher" ,
        Reconnaissance : "Reconnaissance missions" ,
        Enable_Reconnaissance : "Enable Reconnaissance" ,
        no_reconnaissance_missions_available : "No reconnaissance missions available" ,
        checking_permissions : "Checking permissions..." ,
        Notes : "Notes" ,
        Next : "Next" ,
        previous : "previous" ,
        Add_Question : "Add Question" ,
        Questions : "Questions" ,
        Save : "Save" ,
        SaveAdmin : "Save Admin Questionnaire" ,
        Take_photos : "Take photos" ,
        Yes : "Yes" ,
        No : "No" ,
        Review_Requests : "Review Requests" ,
        Accept : "Accept" ,
        Mission_Details : "Mission Details" ,
        OVERALL_PERFORMANCE : "OVERALL PERFORMANCE" ,
        General_Rating : "General Rating" ,
        SECTION_SUMMARY : "SECTION SUMMARY" ,
        Comments : "Comments" ,
        Questions_Answers : "Questions Answers" ,
        show_Report : "show Report" ,
        Print_Report : "Print Report" ,
        New_Mission : "New Mission" ,
        Wait_Requests : "Wait Requests" , 
        Pending_user_Acceptance : "Pending user Acceptance" ,
        Current_Missions : "Current Missions" ,
        Complete_Missions : "Complete Missions" ,
        CanceledMissions : "Canceled Missions" ,
        Missions: 'Missions',
        update : "Update" ,
        visitor_Rating : "Visitor Rating" ,
        MysteryProfile : "Mystery Profile" ,
        MissionDetails : "Mission Details" ,
        Cancel : "Cancel" ,
        Delete : "Delete" ,
        Focus : "Focus" ,
        locationAndTime : "location And Time" ,
        ReviewRequests : "Review Requests" ,
        RateTheVisitor  : "Rate The Visitor" ,
        Confirm : "Confirm" ,
        VisitorName : "Visitor Name" ,
        VisitorGender : "Visitor Gender" , 
        VisitorPhone :"Visitor Phone" , 
        VisitorEmail : "Visitor Email" , 
        CompanyName : "Company Name" ,
        MissionDate : "Mission Date" ,
        MissionTime : "Mission Time" ,
        BranchAddress : "Branch Address" ,
        CompanyWebsite : "Company Website" ,
        CommercialRegistrationNo : "Commercial Registration No" ,
        AvailableMissions : "Available Missions" ,
        totalBalance : "total Balance" ,
        NewBranch : "New Branch" ,
        Add : "Add" ,
        Required : "Required" ,
        Optional : "Optional" ,
        EnterAnewAnswer : "Enter A new Answer" ,
        RatingOfAnswerBetween0100 : "Rating Of Answer Between 0-100" ,
        EnterYourQuestion : "Enter Your Question" ,
        Yes : "Yes" ,
        No : "No" ,
        hint : "hint" ,
        TakePhotos : "Take Photos" ,
        chooseAQuestionType : "choose A Question Type" ,
        SingleChoice : "Single Choice" ,
        multiChoice : "multi Choice" ,
        yesOrNo : "yesOrNo" ,
        rating : "rating" ,
        open : "open" ,
        uploadImages : "upload Images" ,
        headLine : "headLine" ,
        Create_New_Questionnaire : "Create New Questionnaire" ,
        Saved_Questioners : "Saved Questioners" ,
        Saved_admin_Questioners : "Admin Questioners" ,
        are_you_sure_you_want_to_save_this_Questionnaire  : "are you sure you want to save this Questionnaire ?" ,
        are_you_sure_you_want_to_delete_this_Questionnaire : "are you sure you want to delete this Questionnaire ?" ,
        Changes_are_not_saved : "Changes are not saved" ,
        edited_successfully : "edited successfully" ,
        branch_deleted_successfully : "branch deleted successfully" ,
        are_you_sure_you_want_to_add_this_mission : "are you sure you want to add this mission ?" ,
        mission_added_successfully : "mission added successfully" ,
        no_available_missions : "You don't have available missions" ,
        please_fill_all_the_fields : "please fill all the fields" ,
        are_you_sure_you_want_to_delete_this_branch : "are you sure you want to delete this branch ?" ,
        are_you_sure_you_want_to_accept_this_visitor : "are you sure you want to accept this visitor ?" ,
        are_you_sure_you_want_to_cancel_this_mission : "are you sure you want to cancel this mission ?" ,
        Employee_accepted_successfully : "Employee accepted successfully" ,
        Failed_to_accept_employee : "Failed to accept employee" ,
        Will_Available_Soon : "Will Available Soon" ,
        Send_again : "Send again" ,
        Enter_your_email : "Enter your phone number" ,
        Please_enter_your_email_address_to_search_for_your_account : "Please enter your number  to search for your account" ,
        email : "phone number" ,
        Please_enter_your_email : "Please enter your phone number" ,
        change_password : "Change Password" ,
        Please_enter_your_new_password_and_confirm_it_to_change_it : "Please enter your new password and confirm it to change it" ,
        password : "Password" ,
        password_lengh : "(8 digits or more)" ,
        confirm_password : "Confirm Password" ,
        please_fill_all_fields : "please fill all fields" ,
        password_and_confirmation_are_not_identical : "password and confirmation are not identical" ,
        Are_you_sure_you_want_to_logout : "Are you sure you want to logout ?" ,
        Logout_successfully : "Logout successfully" ,
        print : "print" ,
        Branches_Report : "Branches Report" ,
        Missions : "Missions" ,
        rate  : "rate" ,
        Error : "Error" ,
        You_dont_have_enough_money_to_create_a_new_mission_with_voucher : "You don’t have enough money to create a new mission with voucher" ,
        Please_enter_a_new_answer : "Please enter a new answer" ,
        Please_enter_a_new_answer_rate : "Please enter a new answer rate" ,
        Rating_must_be_between_0_and_100 : "Rating must be between 0 and 100" ,
        please_add_step_first : "please add step first" ,
        PrintingTime : "Printing Time", 
        General_rate : "General rate" ,
        Number_of_Missions : "Number of Missions" ,
        The_data_has_been_registered_successfully_and_is_awaiting_admin_approval : "The data has been registered successfully and is awaiting admin approval" , 
        excellent : "Excellent" ,
        good : "Good" ,
        natural : "Natural" ,
        bad : "Bad" ,
        no : "No" ,
        yes : "Yes" ,
        categories : "Categories" ,
        choose_category : "Choose Category" ,
        The_additional_amount_due_to_you : "The additional amount due to you" ,
        Additional_amount_due_to_the_visitor : "Additional amount due to the visitor" ,
        reports : "Reports" , 
        qr_codes : "Qr Codes" , 
        Qr_Codes : "QR Codes" ,
        Responses : "Responses" ,
        New_Qr_Code : "New QR Code" ,
        QR_Code_Options : "QR Code Options" ,
        responses : "responses" ,
        Print_PDF : "Print PDF" ,
        PDF_Preview_Mission_Certificate : "PDF Preview - Mission Certificate" ,
        Send_PDF : "Send PDF" ,
        PDF_Generated_and_Sent_Successfully : "PDF Generated and Sent Successfully" ,
        Select_Branch : "Select Branch" ,
        Select_a_branch : "Select a branch" ,
        Count : "Count" ,
        Enter_count : "Enter count" ,
        Please_select_a_branch : "Please select a branch" ,
        Please_enter_a_valid_count : "Please enter a valid count" ,
        Please_enter_a_questionnaire_title : "Please enter a questionnaire title" ,
        QR_Code_Questionnaire_saved_successfully : "QR Code Questionnaire saved successfully" ,
        Question_Required : "Question Required" ,
        Please_enter_a_question_before_saving : "Please enter a question before saving" ,
        OK : "OK" ,
        Options_Required : "Options Required" ,
        Please_fill_in_all_options_before_saving : "Please fill in all options before saving" ,
        Question_Updated : "Question Updated" ,
        Question_has_been_updated_successfully : "Question has been updated successfully" ,
        Question_Added : "Question Added" ,
        Question_has_been_added_successfully : "Question has been added successfully" ,
        Are_you_sure : "Are you sure?" ,
        Do_you_want_to_delete_question : "Do you want to delete question" ,
        Yes_delete_it : "Yes, delete it!" ,
        Deleted : "Deleted!" ,
        Question_has_been_deleted : "Question has been deleted" ,
        No_Questions_Added : "No Questions Added" ,
        Please_add_at_least_one_question_to_continue : "Please add at least one question to continue" ,
        Question : "Question" ,
        Add_Question : "Add Question" ,
        Edit_Question : "Edit Question" ,
        Add_New_Question : "Add New Question" ,
        Enter_your_question : "Enter your question" ,
        Options : "Options" ,
        Option : "Option" ,
        Update_Question : "Update Question" ,
        Quiz : "Quiz" ,
        Quiz_description : "Create quiz questions for your mission" ,
        Add_Option : "Add Option" ,
        question : "Question" ,
        total_answers : "Total Answers" ,
        evaluated_answers : "Evaluated Answers" ,
        QR_Code_1 : "QR Code 1" ,
        QR_Code_2 : "QR Code 2" ,
        QR_Code_3 : "QR Code 3" ,
        One_Branch : "One Branch" ,
        More_than_Branch : "More than Branch" ,
        QR_codes : "QR codes" ,
        Select_branch : "Select branch" ,
        Select_branches : "Select branches" ,
        Select_QR_codes : "Select QR codes" ,
        Reviews_Qualification : "Reviews Qualification" ,
        Positive : "Positive" ,
        Neutral : "Neutral" ,
        Negative : "Negative" ,
        Sections : "Sections" ,
        The_percentage_of_improvement_of_the_branch_during_the_specified_period_of_time : "The percentage of improvement of the branch during the specified period of time" ,
        Average_sum_of_sections_for_all_tasks_for_the_same_branch : "Average sum of sections for all tasks for the same branch" ,
        Rate_of_development_in_each_section : "Rate of development in each section" ,
        Previous_Month : "Previous Month" ,
        Current_Month : "Current Month" ,
        first : "first" ,
        second : "second" ,
        Department_development_rate : "Department development rate" ,
        choose_step : "choose step" ,
        Today : "Today" ,
        Yesterday : "Yesterday" ,
        this_week : "this week" ,
        last_week : "last week" ,
        this_month : "this month" ,
        last_month : "last month" ,
        this_year : "this year" ,
        last_year : "last year" ,
        all_times : "all times" ,
        Selected_Range : "Selected Range" ,
        Apply : "Apply" ,
        Show_Quiz : "Show Quiz" ,
        Quiz_Results : "Quiz Results" ,
        Question : "Question" ,
        Correct : "Correct" ,
        Incorrect : "Incorrect" ,
        Correct_Answer : "Correct Answer" ,
        User_Answer : "Visitor Answer" ,
        Total_Questions : "Total Questions" ,
        Correct_Answers : "Correct Answers" ,
        Score : "Score" ,
        No_Quiz_Data_Available : "No quiz data available" ,
        No_Report_Available : "There is no report" ,
        Company_Name : "Company Name" ,
        view_profile : "view profile" ,
        Sign_out : "Sign out" ,
        // Wallet translations
        wallet : "Wallet" ,
        My_Wallet : "My Wallet" ,
        current_balance : "Current Balance" ,
        Transactions : "Transactions" ,
        total_expenses : "Total Expenses" ,
        pending : "Pending" ,
        statistics : "Statistics" ,
        no_transactions_found : "No Transactions Found" ,
        no_transactions_message : "You don't have any transactions yet." ,
        transaction_id : "ID" ,
        transaction_status : "Status" ,
        transaction_amount : "Amount" ,
        balance_before : "Balance Before" ,
        balance_after : "Balance After" ,
        operation_type : "Type" ,
        transaction_date : "Date" ,
        download_excel : "Download Excel" ,
        success : "SUCCESS" ,
        failed : "FAILED" ,
        pending_status : "PENDING" ,
        // Subscription Transactions translations
        start_date : "Start Date" ,
        end_date : "End Date" ,
        Status : "Status" ,
        Inactive : "Inactive" ,
        Active : "Active" ,
        No_subscriptions_found : "No subscriptions found" ,
        // QR Codes Report translations
        reconnaissance : "Reconnaissance Visits" ,
        done_qr_codes : "Done Qr codes" ,
        running_qr_codes : "Running Qr Codes" ,
        general_rate : "General Rate" ,
        bad : "Bad" ,
        good : "Good" ,
        normal : "Normal" ,
        excellent : "Excellent" ,
        reviews_qualification : "Reviews Qualification" ,
        positive : "Positive" ,
        neutral : "Neutral" ,
        negative : "Negative" ,
        high_low_sections : "High & Low Sections" ,
        section : "Section" ,
        average_total_evaluation : "Average total evaluation for each section" ,
        overall_rating_qr_codes : "Overall rating for each QR code" ,
        // More Than Branch Report translations
        top_3_branches_rating : "Top 3 branches in terms of rating" ,
        evaluation_questions_branch : "Evaluation of questions for each branch" ,
        overall_evaluation_branch : "Overall evaluation of each branch" ,
        average_step_ratings : "Average step ratings over a specific period of time" ,
        average_branch_ratings : "Average ratings of all branches over a specific period of time" ,
        development_rate_branch : "The development rate in each step for all branches" ,
        compare_sections_branches : "Compare sections for branches" ,
        choose_step : "choose step" ,
        sections : "Sections" ,
        old_average : "Old Average" ,
        new_average : "New Average" ,
        branch_evaluation_in_relation_to_time : "Branch evaluation in relation to time" ,
        // Home2 translations
        overview : "Overview" ,
        excellent : "Excellent" ,
        available_missions : "Available Visits" ,
        add_more : "addMore" ,
        last_purchase : "LastPurchase 25 Missions" ,
        current_balance : "CurrentBalance" ,
        last_transaction : "lastTransaction" ,
        avg_review : "AvgReview" ,
        branches_report : "Branches Report" ,
        missions : "missions" ,
        rate : "rate" ,
        rating : "Rating" ,
        branch : "Branch" ,
        section : "Section" ,
        branches_saudi_arabia : "Branches in Saudi Arabia" ,
        // Responses translations
        responses : "Responses" ,
        qr_code_name : "QR Code Name" ,
        branch_name : "Branch Name" ,
        date : "Date" ,
        percentage_score : "Percentage Score" ,
        id : "Id" ,
        // QR Code Cart translations
        URL : "URL" ,
        Copy : "Copy" ,
        Copied : "Copied" ,
        Copy_URL : "Copy URL" ,
        // Mission translations
        Gender : "Gender" ,
        Male : "Male" ,
        Female : "Female" ,
        All : "All" ,
        Select_branches : "Select branches" ,
        Details : "Details" ,
        Bio : "Bio" ,
        // Questions Modal translations
        Response_Details : "Response Details" ,
        Response_Summary : "Response Summary" ,
        Submission_Time : "Submission Time" ,
        Total_Score : "Total Score" ,
        Correct_Answers : "Correct Answers" ,
        Wrong_Answers : "Wrong Answers" ,
        Questions_and_Answers : "Questions and Answers" ,
        Answer : "Answer" ,
        Available_Choices : "Available Choices" ,
        Questionnaire_Details : "Questionnaire Details" ,
        Questionnaire_Information : "Questionnaire Information" ,
        ID : "ID" ,
        Title : "Title" ,
        Steps : "Steps" ,
        Questions : "Questions" ,
        Question_ID : "Question ID" ,
        Type : "Type" ,
        Choices : "Choices" ,
        Close : "Close" ,
        // Branch Edit translations
        Update_Branch : "Update Branch" ,
        Updating : "Updating..." ,
        Please_fill_in_all_fields : "Please fill in all fields" ,
        
        // PDF Report translations
        One_Branch_Report : "One Branch Report" ,
        More_than_Branch_Report : "More than Branch Report" ,
        QR_Codes_Report : "QR Codes Report" ,
        Generating_PDF : "Generating PDF" ,
        Please_wait : "Please wait..." ,
        Success : "Success" ,
        PDF_generated_successfully : "PDF generated successfully" ,
        Failed_to_generate_PDF : "Failed to generate PDF" ,
        Ok : "Ok" ,
        // Print Note Modal translations
        Add_Note_Before_Print : "Add Note Before Print" ,
        Enter_note_optional : "Enter note (optional)" ,
        Print_with_Note : "Print with Note" ,
        PDF_generated_successfully : "PDF generated successfully" ,
        Ok : "Ok" ,
        Error : "Error" ,
        Failed_to_generate_PDF : "Failed to generate PDF" ,
        Steps : "Steps" ,
        No_steps_available : "No steps available" ,
        // Add New Step translations
        add_new_step : "Add New Step",
        step_name : "Step Name",
        enter_step_name : "Enter step name...",
        add_step : "Add Step",
        cancel : "Cancel",
        you_need_to_write_a_step_name : "You need to write a step name!",
        step_added_successfully : "Step added successfully",
        update_step : "Update Step",
        update_step_button : "Update Step",
        are_you_sure : "Are you sure?",
        delete_step_confirmation : "Do you want to delete step \"{{stepName}}\"?",
        yes_delete_it : "Yes, delete it!",
        step_updated_successfully : "Step updated successfully",
        step_deleted_successfully : "Step deleted successfully",
        success : "Success",
        ok : "OK",
        request_failed : "فشل الطلب: {{error}}",
        // QR Code Cart translations
        qr_code : "QR Code" ,
        Delete_QR_Code : "Delete QR Code" ,
        View_QR_Code_Options : "View QR Code Options" ,
        Location : "Location" ,
        QR_Code_Image : "QR Code Image" ,
        Open_URL_in_new_tab : "Open URL in new tab" ,
        Print_QR_Code_as_PDF : "Print QR Code as PDF" ,
        Print : "Print" ,
        Delete_QR_Code_Confirmation : "Are you sure you want to delete this QR Code? This action cannot be undone." ,
        QR_Code_deleted_successfully : "QR Code has been deleted successfully" ,
        Failed_to_delete_QR_Code : "Failed to delete QR Code. Please try again." ,
        Something_went_wrong : "Something went wrong. Please try again." ,
        No_category : "No category" ,
        // City names translations
        Riyadh : "Riyadh" ,
        Jeddah : "Jeddah" ,
        Dammam : "Dammam" ,
        Mecca : "Mecca" ,
        Medina : "Medina" ,
        Abha : "Abha" ,
        Jizan : "Jizan" ,
        Tabuk : "Tabuk" ,
        Najran : "Najran" ,
        AlBaha : "Al Baha" ,
        Hafar_AlBatin : "Hafar Al-Batin" ,
        AlKhobar : "Al Khobar" ,
        PDF_Preview_Mission_Certificate: "PDF Preview - Mission Certificate",
        Cancel: "Cancel",
        Send_PDF: "Send PDF",
        Download: "Download" , 
        done_responses : "Done Responses",  
        remaining_responses : "Remaining Responses" ,
        Branches : "Branches" ,
        
      },
      content: {}
    }
  },
  ar: {
    translation: {
      label: {},
      error: {},
      message: {},
      text: 
      { 
        empty  :"" ,
        hello: "أهلا"  , 
        company_name : "اسم الشركة" ,  
        home : "الصفحة الرئيسية" , 
        missions : "المهمات" , 
        questionnaires : "الاستبيانات" , 
        subscription : "الاشتراك"  , 
        Company_name : "إسم الشركة" ,
        Company_Website : "رابط الموقع الالكتروني للشركة " ,
        Company_Email : "البريد الالكتروني للشركة" ,
        Password : "كلمة المرور" , 
        Confirm_Password : "تأكيد كلمة المرور" ,
        Commercial_Registration_No : "رقم السجل التجاري " , 
        Copy_of_the_commercial_register : "نسخة من السجل التجاري" , 
        Upload: "رفع" , 
        Create_Account : "إنشاء حساب"  , 
        The_application_is_currently_being_reviewed : "طلب التقديم قيد المراجعة حاليًا" , 
        We_will_contact_you_to_verify_the_data_and_some_other_information : "سوف نقوم بالاتصال بك للتحقق من البيانات وبعض المعلومات الأخرى" , 
        Visit_Site : "زيارة الموقع" , 
        Welcome_back : "أهلا بعودتك " , 
        Phone_Number : " رقم الهاتف " , 
        Forget_Password : "نسيت كلمة السر ؟ " ,
        Login : "تسجيل الدخول" , 
        Didnt_have_an_account : " لا تملك حساب ؟ " , 
        Register : " إنشاء حساب " , 
        Enter_your_phone_number : "أدخل رقم الهاتف الخاص بك" , 
        We_need_your_phone_number_to_create_an_account_and_log_in_with_later : "نحتاج إلى رقم هاتفك لإنشاء حساب وتسجيل الدخول به لاحقًا" , 
        confirm :"تأكيد" , 
        You_will_receive_an_email_with_a_verification_code_on :  "ستتلقى رسالة   تحتوي على رمز التحقق على" , 
        Verify : "تأكيد" , 
        change : "تغيير" , 
        Didnt_receive_anything : "لم تتلق أي شيء؟" , 
        Send_again_after : "إرسال مرة أخرى بعد" , 
        seconds : "ثانية" , 
        Available_Missions : "الزيارات المتاحة" , 
        Highest_rating : "أعلى تصنيف" , 
        Lowest_rating : "أقل تصنيف" , 
        New_Missions : "المهمات الجديدة " , 
        published : "نشرت" , 
        noMissions : "لا يوجد اي مهمات " , 
        Support : "الدعم الفني " , 
        Messages : "الرسائل" ,
        Mystery_Support : "دعم ميستري" , 
        select_a_message_from_the_side_bar : "اختر رسالة من الشريط الجانبي" ,
        Send : "إرسال" ,
        Enter_Message : "أدخل رسالة" ,
        Post_Mission : "نشر المهمة" ,
        Title : "العنوان" ,
        Focus : "التركيز" ,
        Branch : "الفرع" ,
        Date : "التاريخ" ,
        Time : "الوقت" ,
        from : "من" ,
        to : "إلى" ,
        Purchase_voucher : "قسيمة شراء" ,
        Questionnaire : "الاستبيان" ,
        total_balance : "الرصيد الكلي" ,
        SAR : "ريال" ,
        New_Mission : "مهمة جديدة" ,
        type_what_you_want_him_her_to_focus_on : "اكتب ما تريد أن يركز عليه ! " ,
        Include_Purchase_voucher : "تضمين قسيمة شراء" ,
        Reconnaissance : "مهمة استطلاع" ,
        Enable_Reconnaissance : "تفعيل الاستطلاع" ,
        no_reconnaissance_missions_available : "لا توجد مهام استطلاع متاحة" ,
        checking_permissions : "جاري التحقق من الصلاحيات..." ,
        Notes : "ملاحظات" ,
        Next : "التالي" ,
        previous : "السابق" ,
        Add_Question : "إضافة سؤال" ,
        Save : "حفظ" ,
        SaveAdmin : "حفظ استبيان الادمن" ,
        Questions : "الأسئلة" ,
        Take_photos : "التقط الصور" ,
        Yes : "نعم" ,
        No : "لا" ,
        Review_Requests : "مراجعة الطلبات" ,
        Accept : "قبول" ,
        Mission_Details : "تفاصيل المهمة" ,
        OVERALL_PERFORMANCE : "الأداء العام" ,
        General_Rating : "التقييم العام " ,
        SECTION_SUMMARY : "ملخص القسم" ,
        Comments : "التعليقات" ,
        Questions_Answers : "الأسئلة والأجوبة" ,
        show_Report : "عرض التقرير" ,
        Print_Report : "طباعة التقرير" ,
        New_Mission : "مهمة جديدة" ,
        Wait_Requests : "انتظار الطلبات" ,
        Pending_user_Acceptance : "انتظار قبول المستخدم" ,
        Current_Missions : "المهمات الحالية" ,
        Complete_Missions : "المهمات المكتملة" ,
        CanceledMissions : "المهمات الملغية" ,
        Missions: 'المهمات',
        update : "تحديث" ,
        visitor_Rating : "تقييم الزائر" ,
        MysteryProfile : "ملف الزائر" ,
        MissionDetails : "تفاصيل المهمة" ,
        Cancel : "إلغاء" ,
        Delete : "حذف" ,
        Focus : "التركيز" ,
        locationAndTime : "الموقع والوقت" ,
        ReviewRequests : "مراجعة الطلبات" ,
        RateTheVisitor  : "قيم الزائر" ,
        Confirm : "تأكيد" ,
        VisitorName : "اسم الزائر" ,
        VisitorGender : "جنس الزائر" , 
        VisitorPhone : "جوال الزائر" ,  
        VisitorEmail : "ايميل الزائر" , 
        CompanyName : "اسم الشركة" ,
        MissionDate : "تاريخ المهمة" ,
        MissionTime : "وقت المهمة" ,
        BranchAddress : "عنوان الفرع" ,
        CompanyWebsite : "الموقع الالكتروني للشركة" ,
        CommercialRegistrationNo : "رقم السجل التجاري" ,
        AvailableMissions : "مهمة متاحة" ,
        totalBalance : "الرصيد الكلي" ,
        NewBranch : "فرع جديد" ,
        Add : "أضف" ,
        Required : "مطلوب" ,
        Optional : "اختياري" ,
        EnterAnewAnswer : "أدخل إجابة جديدة" ,
        RatingOfAnswerBetween0100 : "تقييم الإجابة من 0-100" ,
        EnterYourQuestion : "أدخل سؤالك" ,
        Yes : "نعم" ,
        No : "لا" ,
        hint : "تلميح" ,
        TakePhotos : "التقط الصور" ,
        chooseAQuestionType : "اختر نوع السؤال" ,
        SingleChoice : "اختيار واحد" ,
        multiChoice : "اختيار متعدد" ,
        yesOrNo : "نعم أو لا" ,
        rating : "تقييم" ,
        open : "مفتوح" ,
        uploadImages : "تحميل صور" ,
        headLine : "عنوان" ,
        Create_New_Questionnaire : "إنشاء استبيان جديد" ,
        Saved_Questioners : "الاستبيانات المحفوظة" ,
        Saved_admin_Questioners : " استبيانات الادمن" ,
        are_you_sure_you_want_to_save_this_Questionnaire : "هل أنت متأكد أنك تريد حفظ هذا الاستبيان؟" , 
        are_you_sure_you_want_to_delete_this_Questionnaire : "هل أنت متأكد أنك تريد حذف هذا الاستبيان؟" ,
        Changes_are_not_saved : "التغييرات غير محفوظة" ,
        edited_successfully : "تم التعديل بنجاح" ,
        branch_deleted_successfully : "تم حذف الفرع بنجاح" ,
        are_you_sure_you_want_to_add_this_mission : "هل أنت متأكد أنك تريد إضافة هذه المهمة؟" ,
        mission_added_successfully : "تمت إضافة المهمة بنجاح" ,
        no_available_missions : "لا توجد مهمات متاحة" ,
        please_fill_all_the_fields : "يرجى ملء جميع الحقول" ,
        are_you_sure_you_want_to_delete_this_branch : "هل أنت متأكد أنك تريد حذف هذا الفرع؟" ,
        are_you_sure_you_want_to_accept_this_visitor : "هل أنت متأكد أنك تريد قبول هذا الزائر؟" ,
        are_you_sure_you_want_to_cancel_this_mission : "هل أنت متأكد أنك تريد إلغاء هذه المهمة؟" ,
        Employee_accepted_successfully : "تم قبول الموظف بنجاح" ,
        Failed_to_accept_employee : "فشل في قبول الموظف" ,
        Will_Available_Soon : "سيتوفر قريبا  " ,
        Send_again : "إرسال مرة أخرى" ,
        Enter_your_email : "أدخل  رقم الجوال" ,
        Please_enter_your_email_address_to_search_for_your_account : "يرجى إدخال   رقم الجوال للبحث عن حسابك" ,
        email : " رقم الهاتف" ,
        Please_enter_your_email : "الرجاء إدخال  رقم الجوال" ,
        change_password : "تغيير كلمة المرور" ,
        Please_enter_your_new_password_and_confirm_it_to_change_it : "الرجاء إدخال كلمة المرور الجديدة وتأكيدها لتغييرها" ,
        password : "كلمة المرور" ,
        password_lengh : " ( 8 حروف او أكثر)" ,
        confirm_password : "تأكيد كلمة المرور" ,
        please_fill_all_fields : "يرجى ملء جميع الحقول" ,
        password_and_confirmation_are_not_identical : "كلمة المرور والتأكيد غير متطابقين" ,
        Are_you_sure_you_want_to_logout : "هل أنت متأكد أنك تريد تسجيل الخروج؟" ,
        Logout_successfully : "تم تسجيل الخروج بنجاح" ,
        print : "طباعة" , 
        Branches : "الفروع" ,
        Branches_Report : "تقرير الفروع" ,
        Missions : "مهمة" ,
        rate  : "التقييم" ,
        Error : "خطأ" ,
        You_dont_have_enough_money_to_create_a_new_mission_with_voucher : "لا يوجد رصيد كافٍ لإنشاء مهمة جديدة باستخدام قسيمة الشراء" ,
        Please_enter_a_new_answer : "الرجاء إدخال إجابة جديدة" ,
        Please_enter_a_new_answer_rate : "الرجاء إدخال تقييم للإجابة الجديدة" ,
        Rating_must_be_between_0_and_100 : "يجب أن يكون التقييم بين 0 و 100" ,
        please_add_step_first : "يرجى إضافة خطوة أولا" ,
        PrintingTime : "وقت الطباعة" , 
        General_rate : "التقييم العام" , 
        Number_of_Missions : "عدد المهمات" ,
        The_data_has_been_registered_successfully_and_is_awaiting_admin_approval : "تم تسجيل البيانات بنجاح وفي انتظار موافقه الادمن"  , 
        excellent : "ممتاز" ,
        good : "جيد" ,
        natural : "طبيعي" ,
        bad : "سيء" ,
        no : "لا" ,
        yes : "نعم" ,
        categories : "الفئات" ,
        choose_category : "اختر قسم" ,
        The_additional_amount_due_to_you : "المبلغ الإضافي المستحق لك" ,
        Additional_amount_due_to_the_visitor : "المبلغ الإضافي المستحق للزائر" ,
        reports : "التقارير"  , 
        qr_codes : "رموز المسموع" , 
        Qr_Codes : "رموز المسموع" ,
        Responses : "الردود" ,
        New_Qr_Code : " المسموع جديد" ,
        QR_Code_Options : "خيارات  المسموع" ,
        responses : "ردود" ,
        Print_PDF : "طباعة PDF" ,
        PDF_Generated_and_Sent_Successfully : "تم إنشاء وإرسال PDF بنجاح" ,
        Select_Branch : "اختر الفرع" ,
        Select_a_branch : "اختر فرع" ,
        Count : "العدد" ,
        Enter_count : "أدخل العدد" ,
        Please_select_a_branch : "يرجى اختيار فرع" ,
        Please_enter_a_valid_count : "يرجى إدخال عدد صحيح" ,
        Please_enter_a_questionnaire_title : "يرجى إدخال عنوان الاستبيان" ,
        QR_Code_Questionnaire_saved_successfully : "تم حفظ استبيان  المسموع بنجاح" ,
        Question_Required : "السؤال مطلوب" ,
        Please_enter_a_question_before_saving : "يرجى إدخال سؤال قبل الحفظ" ,
        OK : "موافق" ,
        Options_Required : "الخيارات مطلوبة" ,
        Please_fill_in_all_options_before_saving : "يرجى ملء جميع الخيارات قبل الحفظ" ,
        Question_Updated : "تم تحديث السؤال" ,
        Question_has_been_updated_successfully : "تم تحديث السؤال بنجاح" ,
        Question_Added : "تم إضافة السؤال" ,
        Question_has_been_added_successfully : "تم إضافة السؤال بنجاح" ,
        Are_you_sure : "هل أنت متأكد؟" ,
        Do_you_want_to_delete_question : "هل تريد حذف السؤال" ,
        Yes_delete_it : "نعم، احذفه!" ,
        Deleted : "تم الحذف!" ,
        Question_has_been_deleted : "تم حذف السؤال" ,
        No_Questions_Added : "لم يتم إضافة أسئلة" ,
        Please_add_at_least_one_question_to_continue : "يرجى إضافة سؤال واحد على الأقل للمتابعة" ,
        Question : "السؤال" ,
        Add_Question : "إضافة سؤال" ,
        Edit_Question : "تعديل السؤال" ,
        Add_New_Question : "إضافة سؤال جديد" ,
        Enter_your_question : "أدخل سؤالك" ,
        Options : "الخيارات" ,
        Option : "الخيار" ,
        Update_Question : "تحديث السؤال" ,
        Quiz : "الاختبار" ,
        Quiz_description : "أنشئ أسئلة إختبار لمهمتك" ,
        Add_Option : "إضافة خيار" ,
        question : "السؤال" ,
        total_answers : "إجمالي الإجابات" ,
        evaluated_answers : "الإجابات المقيمة" ,
        QR_Code_1 : " مسموع 1" ,
        QR_Code_2 : " مسموع 2" ,
        QR_Code_3 : " مسموع 3" ,
        One_Branch : "فرع واحد" ,
        More_than_Branch : "أكثر من فرع" ,
        QR_codes : "رموز المسموع" ,
        Select_branch : "اختر فرع" ,
        Select_branches : "اختر فروع" ,
        Select_QR_codes : "اختر رموز المسموع" ,
        Reviews_Qualification : "تأهيل المراجعات" ,
        Positive : "إيجابي" ,
        Neutral : "محايد" ,
        Negative : "سلبي" ,
        Sections : "الأقسام" ,
        The_percentage_of_improvement_of_the_branch_during_the_specified_period_of_time : "نسبة تحسن الفرع خلال الفترة المحددة من الزمن" ,
        Average_sum_of_sections_for_all_tasks_for_the_same_branch : "متوسط مجموع الأقسام لجميع المهام لنفس الفرع" ,
        Rate_of_development_in_each_section : "معدل التطوير في كل قسم" ,
        Previous_Month : "الشهر السابق" ,
        Current_Month : "الشهر الحالي" ,
        first : "أول" ,
        second : "ثاني" ,
        Department_development_rate : "معدل تطوير القسم" ,
        choose_step : "اختر خطوة" ,
        Today : "اليوم" ,
        Yesterday : "أمس" ,
        this_week : "هذا الأسبوع" ,
        last_week : "الأسبوع الماضي" ,
        this_month : "هذا الشهر" ,
        last_month : "الشهر الماضي" ,
        this_year : "هذا العام" ,
        last_year : "العام الماضي" ,
        all_times : "كل الأوقات" ,
        Selected_Range : "النطاق المحدد" ,
        Apply : "تطبيق" ,
        Show_Quiz : "عرض الاختبار" ,
        Quiz_Results : "نتائج الاختبار" ,
        Question : "السؤال" ,
        Correct : "صحيح" ,
        Incorrect : "خطأ" ,
        Correct_Answer : "الإجابة الصحيحة" ,
        User_Answer : "إجابة الزائر" ,
        Total_Questions : "إجمالي الأسئلة" ,
        Correct_Answers : "الإجابات الصحيحة" ,
        Score : "الدرجة" ,
        No_Quiz_Data_Available : "لا توجد بيانات اختبار متاحة" ,
        No_Report_Available : "لا يوجد تقرير" ,
        Company_Name : "اسم الشركة" ,
        view_profile : "عرض الملف الشخصي" ,
        Sign_out : "تسجيل الخروج" ,
        // Wallet translations
        wallet : "المحفظة" ,
        My_Wallet : "محفظتي" ,
        current_balance : "الرصيد الحالي" ,
        Transactions : "المعاملات" ,
        total_expenses : "المصاريف الكلية" ,
        pending : "في انتظار" ,
        statistics : "الإحصائيات" ,
        no_transactions_found : "لم يتم العثور على عمليات" ,
        no_transactions_message : "لا توجد عمليات بعد." ,
        transaction_id : "المعرف" ,
        transaction_status : "الحالة" ,
        transaction_amount : "المبلغ" ,
        balance_before : "الرصيد قبل" ,
        balance_after : "الرصيد بعد" ,
        operation_type :"نوع العملية",
        transaction_date : "التاريخ" ,
        download_excel : "تحميل Excel" ,
        success : "نجاح" ,
        failed : "فشل" ,
        pending_status : "في انتظار" ,
        // Subscription Transactions translations
        start_date : "تاريخ البدء" ,
        end_date : "تاريخ الانتهاء" ,
        Status : "الحالة" ,
        Inactive : "غير نشط" ,
        Active : "نشط" ,
        No_subscriptions_found : "لم يتم العثور على اشتراكات" ,
        // مسموع Codes Report translations
        reconnaissance : "زيارات الاستطلاع" ,
        done_qr_codes : "رموز المسموع التامة" ,
        running_qr_codes : "رموز المسموع التشغيلية" ,
        general_rate : "التقييم العام" ,
        bad : "سيء" ,
        good : "جيد" ,
        normal : "عادي" ,
        excellent : "ممتاز" ,
        reviews_qualification : "تأهيل المراجعات" ,
        positive : "إيجابي" ,
        neutral : "محايد" ,
        negative : "سلبي" ,
        high_low_sections : "الأقسام العالية والمنخفضة" ,
        section : "القسم" ,
        average_total_evaluation : "التقييم الكلي المتوسط لكل قسم" ,
        overall_rating_qr_codes : "التصنيف العام لكل  مسموع" ,
        // More Than Branch Report translations
        top_3_branches_rating : "أفضل 3 فروع من حيث التقييم" ,
        evaluation_questions_branch : "تقييم الأسئلة لكل فرع" ,
        overall_evaluation_branch : "التقييم العام لكل فرع" ,
        average_step_ratings : "متوسط تقييمات الأقسام خلال فترة زمنية محددة" ,
        average_branch_ratings : "متوسط تقييمات جميع الفروع خلال فترة زمنية محددة" ,
        development_rate_branch : "معدل التطوير في كل قسم لجميع الفروع" ,
        compare_sections_branches : "مقارنة الأقسام للفروع" ,
        choose_step : "اختر خطوة" ,
        sections : "الأقسام" ,
        old_average : "المتوسط القديم" ,
        new_average : "المتوسط الجديد" ,
        branch_evaluation_in_relation_to_time : "تقييم الفرع بالنسبة للوقت" ,
        // Home2 translations
        overview : "الملخص" ,
        excellent : "ممتاز" ,
        available_missions : "الزيارات المتاحة" ,
        add_more : "إضافة المزيد" ,
        last_purchase : "آخر شراء 25 مهمة" ,
        current_balance : "الرصيد الحالي" ,
        last_transaction : "آخر عملية" ,
        avg_review : "متوسط التقييم" ,
        branches_report : "تقرير الفروع" ,
        missions : "المهمات" ,
        rate : "التقييم" ,
        rating : "التصنيف" ,
        branch : "الفرع" ,
        section : "القسم" ,
        branches_saudi_arabia : "الفروع في المملكة العربية السعودية" ,
        // Responses translations
        responses : "الردود" ,
        qr_code_name : "اسم  المسموع" ,
        branch_name : "اسم الفرع" ,
        date : "التاريخ" ,
        percentage_score : "النسبة المئوية للدرجة" ,
        id : "المعرف" ,
        // مسموع Code Cart translations
        URL : "الرابط" ,
        Copy : "نسخ" ,
        Copied : "تم النسخ" ,
        Copy_URL : "نسخ الرابط" ,
        // Mission translations
        Gender : "الجنس" ,
        Male : "ذكر" ,
        Female : "أنثى" ,
        All : "الكل" ,
        Select_branches : "اختر الفروع" ,
        Details : "التفاصيل" ,
        Bio : "نبذة تعريفية" ,
        // Questions Modal translations
        Response_Details : "تفاصيل الرد" ,
        Response_Summary : "ملخص الرد" ,
        Submission_Time : "وقت التقديم" ,
        Total_Score : "الدرجة الكلية" ,
        Correct_Answers : "الإجابات الصحيحة" ,
        Wrong_Answers : "الإجابات الخاطئة" ,
        Questions_and_Answers : "الأسئلة والإجابات" ,
        Answer : "الإجابة" ,
        Available_Choices : "الخيارات المتاحة" ,
        Questionnaire_Details : "تفاصيل الاستبيان" ,
        Questionnaire_Information : "معلومات الاستبيان" ,
        ID : "المعرف" ,
        Title : "العنوان" ,
        Steps : "الأقسام" ,
        Questions : "الأسئلة" ,
        Question_ID : "معرف السؤال" ,
        Type : "النوع" ,
        Choices : "الخيارات" ,
        Close : "إغلاق" ,
        // Branch Edit translations
        Update_Branch : "تحديث الفرع" ,
        Updating : "جاري التحديث..." ,
        Please_fill_in_all_fields : "يرجى ملء جميع الحقول" ,
        
        // PDF Report translations
        One_Branch_Report : "تقرير فرع واحد" ,
        More_than_Branch_Report : "تقرير أكثر من فرع" ,
        QR_Codes_Report : "تقرير رموز الاستجابة السريعة" ,
        Generating_PDF : "جاري إنشاء ملف PDF" ,
        Please_wait : "يرجى الانتظار..." ,
        Success : "نجحت العملية" ,
        PDF_generated_successfully : "تم إنشاء ملف PDF بنجاح" ,
        Failed_to_generate_PDF : "فشل في إنشاء ملف PDF" ,
        Ok : "موافق" ,
        Error : "خطأ" ,
        // Print Note Modal translations
        Add_Note_Before_Print : "إضافة ملاحظة قبل الطباعة" ,
        Enter_note_optional : "أدخل ملاحظة (اختياري)" ,
        Print_with_Note : "طباعة مع الملاحظة" ,
        Steps : "الأقسام" ,
        No_steps_available : "لا توجد أقسام متاحة" ,
        // Add New Step translations
        add_new_step : "إضافة قسم جديد",
        step_name : "اسم القسم",
        enter_step_name : "أدخل اسم القسم...",
        add_step : "إضافة قسم",
        cancel : "إلغاء",
        you_need_to_write_a_step_name : "يجب كتابة اسم القسم!",
        step_added_successfully : "تمت إضافة القسم بنجاح",
        update_step : "تحديث القسم",
        update_step_button : "تحديث القسم",
        are_you_sure : "هل أنت متأكد؟",
        delete_step_confirmation : "هل تريد حذف القسم \"{{stepName}}\"؟",
        yes_delete_it : "نعم، احذفه!",
        step_updated_successfully : "تم تحديث القسم بنجاح",
        step_deleted_successfully : "تم حذف القسم بنجاح",
        success : "نجحت العملية",
        ok : "موافق",
        request_failed : "فشل الطلب: {{error}}",
        // QR Code Cart translations
        qr_code : " المسموع" ,
        Delete_QR_Code : "حذف  المسموع" ,
        View_QR_Code_Options : "عرض خيارات  المسموع" ,
        Location : "الموقع" ,
        QR_Code_Image : "صورة  المسموع" ,
        Open_URL_in_new_tab : "فتح الرابط في تبويب جديد" ,
        Print_QR_Code_as_PDF : "طباعة  المسموع كملف PDF" ,
        Print : "طباعة" ,
        Delete_QR_Code_Confirmation : "هل أنت متأكد من حذف  المسموع هذا؟ لا يمكن التراجع عن هذا الإجراء." ,
        QR_Code_deleted_successfully : "تم حذف  المسموع بنجاح" ,
        Failed_to_delete_QR_Code : "فشل في حذف  المسموع. يرجى المحاولة مرة أخرى." ,
        Something_went_wrong : "حدث خطأ ما. يرجى المحاولة مرة أخرى." ,
        No_category : "لا يوجد فئة" ,
        // City names translations
        Riyadh : "الرياض" ,
        Jeddah : "جدة" ,
        Dammam : "الدمام" ,
        Mecca : "مكة المكرمة" ,
        Medina : "المدينة المنورة" ,
        Abha : "أبها" ,
        Jizan : "جازان" ,
        Tabuk : "تبوك" ,
        Najran : "نجران" ,
        AlBaha : "الباحة" ,
        Hafar_AlBatin : "حفر الباطن" ,
        AlKhobar : "الخبر" ,
        PDF_Preview_Mission_Certificate: "معاينة PDF - شهادة المهمة",
        Cancel: "إلغاء",
        Send_PDF: "إرسال PDF",
        Download: "تحميل" , 
        done_responses : "الردود المكتملة",  
        remaining_responses : "الردود المتبقية" ,
      },
      content: {}
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  interpolation: {
    escapeValue: false
  }
});

export default i18n;